    <template>
        <v-container grid-list-md>
            <v-card class="elevation-10">
                <v-card-text>
                    <p class="title text-xs-center">- My user -</p>

                    <form v-on:submit.prevent="update">

                        <v-layout row wrap>
                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required|email'"
                                        v-model="data.email"
                                        :error-messages="errors.collect('data.email')"
                                        label="Email"
                                        data-vv-name="data.email"
                                        readonly
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        v-validate="'required'"
                                        v-model="data.name"
                                        :error-messages="errors.collect('data.name')"
                                        label="Name"
                                        data-vv-name="data.name"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        type="password"
                                        v-validate="'required'"
                                        v-model="data.password"
                                        :error-messages="errors.collect('data.password')"
                                        label="Password"
                                        data-vv-name="data.password"
                                        ref="password"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs6 s6 md6>
                                <v-text-field
                                        type="password"
                                        v-validate="'required|confirmed:password'"
                                        label="Repeat password"
                                        name="confirmation"
                                        data-vv-as="password"
                                        data-vv-name="data.password"
                                        v-model="data.confirmation"
                                ></v-text-field>
                            </v-flex>

                            <v-flex>
                                <v-btn large color="secondary" class="text--primary" type="submit">Save</v-btn>
                                 <v-btn large color="gray" class="text--primary" @click="$router.go(-1)">Cancel</v-btn>
                            </v-flex>
                        </v-layout>
                    </form>
                </v-card-text>
            </v-card>
        </v-container>
</template>

<script>

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        data : function() {
            return {
                data : {
                    name: '',
                    email : '',
                    password : '',
                    confirmation: ''
                }
            }
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods : {
            update : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('updateProfile', this.data).then((res) => {

                        }).catch((error) => {
                        });
                    }
                });
            }
        },
        created () {
            this.data.name = this.$store.getters.getUser.name;
            this.data.email = this.$store.getters.getUser.email;
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/profile/ProfileComponent.vue